import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AdminApp } from './AdminApp'
import { ADMIN_STORAGE_KEY, AuthProvider } from '../auth/AuthContext'
import { I18nProvider } from '../i18n/I18nProvider'
import { ThemeProvider, ToastProvider } from '../components/ui'
import '../styles.css'

const container = document.getElementById('root')

if (container === null) {
  throw new Error("L'élément racine #root est absent de admin/index.html.")
}

// Même ordre que l'application des exploitants (src/main.tsx). La session a sa propre clé
// et ne charge pas de modules : un super-administrateur n'en souscrit aucun.
createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <ToastProvider>
          <AuthProvider storageKey={ADMIN_STORAGE_KEY} withModules={false}>
            <BrowserRouter>
              <AdminApp />
            </BrowserRouter>
          </AuthProvider>
        </ToastProvider>
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
)
